import React from "react";
import { blue } from "@mui/material/colors";
import AssignmentIndRoundedIcon from "@mui/icons-material/AssignmentIndRounded";
import GenericSupportListing from "../GenericSupportListing/GenericSupportListing";

// ===================== CONSTANTS =====================
const PAGE_TITLE = "Pending Approvals";
const API_ENDPOINT = "/support-requests/assigned/pending";

const AssignedRequestsPage = () => {
  return (
    <GenericSupportListing
      pageTitle={PAGE_TITLE}
      apiRoute={API_ENDPOINT}
      showResponseAction={true}
      showViewAction={true}
      PageIcon={<AssignmentIndRoundedIcon color="white" fontSize="large" />}
      iconColor={blue[700]}
    />
  );
};

export default AssignedRequestsPage;
